import colors from 'constants/color'
import { createTheme } from '@mui/material'
import baseTheme from 'config/theme/base'
import { ThemeMode } from 'enums'

const lightTheme = createTheme({
  ...baseTheme,
  palette: {
    ...baseTheme.palette,
    mode: ThemeMode.Light,
    background: {
      default: colors.white,
      paper: colors.white,
    },
  },
})

export default lightTheme
